<script>
export default {
  name: "banner",
  props: {
    height: {
      default: () => {
        return '200px'
      }
    },
    type: {
      default: 1
    },
    list: {
      default: () => {
        return [
          require('@/assets/img/banner/1.jpg'),
          require('@/assets/img/banner/2.jpg'),
          require('@/assets/img/banner/3.jpg'),
          require('@/assets/img/banner/4.jpg'),
        ]
      }
    },
    list1: {
      default: () => {
        return [
          require('@/assets/img/banner/5.jpg'),
          require('@/assets/img/banner/6.jpg'),
          require('@/assets/img/banner/7.jpg'),
        ]
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    handClick(sub) {
      this.$emit('handClick', sub)
    }
  }
}
</script>

<template>
  <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
    <van-swipe-item v-for="(item,index) in type===1?list:list1" :key="index">
      <img @click="handClick(index)" :style="{height: height}" style="width: 100%;object-fit: cover" v-if="item?.fileList && item?.fileList?.[0]?.displayFileUrl" :src="item?.fileList?.[0]?.displayFileUrl " alt="">
      <img @click="handClick(index)" :style="{height: height}" style="width: 100%;object-fit: cover" v-else :src="item" alt="">
    </van-swipe-item>
  </van-swipe>
</template>

<style scoped lang="scss">

</style>
